import { FeathersModel } from './feathersModel'

export class WorkerStatus extends FeathersModel {
  static serviceName = 'features/workers/statuses'

  id: number
  hasOverlapWithLeave: boolean
}
